import { SALE_COLOR_COPY_CHANGE_241030 } from "@faire/web-api/indigofair/settings/SALE_COLOR_COPY_CHANGE_241030";

import { useSetting, useAssignSetting } from "./__internal__/useSetting";

export const useSettingUpdateSaleColorCopy = (): boolean => {
  return useSetting(SALE_COLOR_COPY_CHANGE_241030, false);
};

export const useAssignSettingUpdateSaleColorCopy = () => {
  return useAssignSetting(SALE_COLOR_COPY_CHANGE_241030);
};
